// Pillows UtilityPage body. Dispatches every block type in `UtilityPageContent`
// (Toolbox + pillows extras) to its React component.
import { Immutable } from "immer";
import React from "react";
import { BannerBlock } from "tsi-common-react/src/components/BannerBlock/index";
import { PromoConditionalBlock } from "tsi-common-react/src/components/PromoConditionalBlock/index";
import { RawHTMLBlock } from "tsi-common-react/src/components/RawHTMLBlock/index";

import { templates } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { AccordionSection } from "../../blocks/AccordionSection";
import { HiddenAnchorLinkBlock } from "../../blocks/HiddenAnchorLinkBlock";
import { TabNav } from "../../blocks/TabNav";
import {
    pillowsPromoConditionalInnerMap,
    toolboxComponentsMap,
} from "../../blocks/toolboxComponentsMap";

type IBodyValue = templates.UtilityPageTemplate["page"]["body"]["value"];

export const UtilityPageBody = (
    props: Immutable<{ value: IBodyValue }>,
): React.JSX.Element => {
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.value}
            components={{
                ...toolboxComponentsMap,
                // UtilityPage overrides ``promo_conditional_block`` with
                // ``PillowsPromoConditionalBlock`` (with content StreamBlock).
                promo_conditional_block: (block) => (
                    <PromoConditionalBlock value={block.value}>
                        <StreamField
                            tagName={React.Fragment}
                            value={block.value.content ?? []}
                            components={pillowsPromoConditionalInnerMap}
                        />
                    </PromoConditionalBlock>
                ),
                heading: (block) => (
                    <h1 className="full title">{block.value}</h1>
                ),
                paragraph: (block) => <RichTextBlock value={block.value} />,
                image: (block) => (
                    <img
                        src={block.value.url}
                        alt={block.value.default_alt_text}
                        width={block.value.width}
                        height={block.value.height}
                        loading="lazy"
                        decoding="async"
                    />
                ),
                html: (block) => <RawHTMLBlock value={block.value} />,
                banner: (block) => <BannerBlock value={block.value} />,
                accordion_section: AccordionSection,
                tab_nav: TabNav,
                hidden_anchor_link: (block) => (
                    <HiddenAnchorLinkBlock value={block.value} />
                ),
            }}
        />
    );
};
